import MoreVertIcon from '@material-ui/icons/MoreVert'
import {
  CardHeader,
  CardContent,
  Grid,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Chip,
  Divider
} from '@material-ui/core'
import { ISolicitacaoKanban } from 'src/contexts/SolicitacoesKanban/types'
import * as S from './styles'
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state'
import React from 'react'
import atividade from 'src/api/atividade'
import UBox from 'src/components/ui/Ubox'
import {
  formatarDataHoraLocal,
  formatarDataLocal,
  formatarHoraLocal
} from 'src/core/formatacoes/formatarData'
import { AiTwotoneThunderbolt } from 'react-icons/ai'
import { BiNetworkChart } from 'react-icons/bi'

interface Props {
  solicitacao?: ISolicitacaoKanban
}

export default function CardSolicitacaoKanban({ solicitacao }: Props) {
  return (
    <S.Card>
      <S.Content>
        <S.Title>
          <Typography variant="body2" component="p">
            <UBox
              style={{
                display: 'flex'
              }}
            >
              <Typography
                variant="body2"
                color="primary"
                style={{
                  padding: '2px 4px',
                  border: '1px solid #eee',
                  borderRadius: '8px',
                  background: '#eee'
                }}
              >
                <b>
                  <small>{solicitacao?.codigo}</small>
                </b>
              </Typography>

              {solicitacao.tipo === 'I' && (
                <Tooltip title="Orçamento instantâneo">
                  <Chip
                    style={{
                      background: 'none'
                    }}
                    label={
                      <AiTwotoneThunderbolt
                        className="icon"
                        style={{
                          fontSize: '26px',
                          paddingTop: '6px',
                          color: '#ebb852'
                        }}
                      />
                    }
                    size="small"
                  />
                </Tooltip>
              )}

              {solicitacao.tipo === 'C' && (
                <Tooltip title="Orçamento cotação">
                  <Chip
                    style={{
                      background: 'none'
                    }}
                    label={
                      <BiNetworkChart
                        className="icon"
                        style={{
                          fontSize: '26px',
                          paddingTop: '6px',
                          color: '#1cc3a5'
                        }}
                      />
                    }
                    size="small"
                  />
                </Tooltip>
              )}
            </UBox>
            <small>
              <b>{`${solicitacao.descricao}`}</b>
            </small>
          </Typography>
        </S.Title>
        <S.MainContent>
          <UBox>
            <S.Label variant="body2">Médico:</S.Label>
            <S.Type variant="body2">{solicitacao.medico.nome}</S.Type>
          </UBox>
          <UBox render={!!solicitacao.paciente}>
            <S.Label variant="body2">Paciente:</S.Label>
            <S.Type variant="body2">{solicitacao?.paciente?.nome}</S.Type>
          </UBox>
          <UBox render={!solicitacao.paciente}>
            <S.Label variant="body2">Solicitação sem paciente</S.Label>
          </UBox>
          <UBox>
            <S.Label variant="body2">
              <i>
                {`Solicitado em ${formatarDataLocal(
                  solicitacao.dataHoraSolicitacao
                )} ás ${formatarHoraLocal(solicitacao.dataHoraSolicitacao)}`}
              </i>
            </S.Label>
            {/* <S.Label variant="body2">Data da solicitação </S.Label> */}
            {/* <S.Type variant="body2">
              {formatarDataHoraLocal(solicitacao.dataHoraSolicitacao)}
            </S.Type> */}
          </UBox>

          <UBox render={solicitacao?.tags?.length > 0}>
            <S.Divider />
            {solicitacao?.tags.map(tag => (
              <S.Tag key={tag.id} label={tag.descricao} size="small" />
            ))}
          </UBox>
        </S.MainContent>
      </S.Content>
      <UBox>
        {' '}
        {/* <PopupState variant="popover" popupId="demo-popup-menu">
          {popupState => (
            <React.Fragment>
              <IconButton
                aria-controls="simple-menu"
                aria-haspopup="true"
                aria-label="mais"
                {...bindTrigger(popupState)}
              >
                <MoreVertIcon />
              </IconButton>

              <Menu
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right'
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right'
                }}
                {...bindMenu(popupState)}
              >
                <MenuItem
                  onClick={() => {
                    // handleEditar(atividade)
                    popupState.close()
                  }}
                >
                  Editar
                </MenuItem>

                <MenuItem
                  onClick={() => {
                    // handleExcluir()
                    popupState.close()
                  }}
                  className="danger"
                  style={{ color: '#ee4343' }}
                >
                  Excluir
                </MenuItem>
              </Menu>
            </React.Fragment>
          )}
        </PopupState> */}
      </UBox>
    </S.Card>
  )
}
